import React from 'react';
import { useSelector } from 'react-redux';

import {
  fieldShouldDisplay,
  handleChange,
  getFieldKey,
  isRequired,
} from '../../../../utils/form';

import FormLabel from './FormLabel';

function Checkbox({
  cols = '12',
  alignBottom,
  disabled,
  name,
  unsetFieldsOnTrue = [],
  unsetFieldsOnFalse = [],
}) {

  const { values, form: { form } } = useSelector(store => store);
  const validationRegex = useSelector(store => store.validation[name]);
  const defaultLabel = useSelector(store => store.labels[name]);
  const { submittedFlag } = useSelector(store => store.enrollment);
  const customLabel = getFieldKey(form, name, 'label');
  const required = isRequired({ form, name, currentValues: values });

  // if field doesn't exist or is conditionally hidden, don't show it.
  if (!fieldShouldDisplay(form, name, values)) return null;

  return (
    <div className={`col-md-${cols} ${alignBottom && 'd-flex align-items-end'}`}>
      <div className="form-check">
        <input
          type="checkbox"
          defaultChecked={values[name]}
          className="form-check-input"
          id={name}
          onChange={(e) => handleChange({
            value: e.target.checked,
            name,
            validationRegex,
            forceValidation: true,
            required,
            unsetFieldsOnTrue,
            unsetFieldsOnFalse,
          })}
          value={values[name] || ''}
          disabled={disabled || submittedFlag}
        />
        <FormLabel className="form-check-label" name={name} label={customLabel || defaultLabel} required={required} />
      </div>
    </div>
  );
}

export default Checkbox;
